import ApiConstants from '../Constants/ApiConstants';
import { AxiosRequestConfig } from 'axios';

/**
 * Get current axios configuration for axios api requests
 * It automatically chooses between default or service mode one
 */
const getDefaultConfiguration = (windowToken: Window): AxiosRequestConfig => {
    const serviceUrl = windowToken?.pageContextManager.getSiteData().serviceUrl;
    let baseURL = new URL(serviceUrl || windowToken?.location.origin).origin;
    return {
        timeout: ApiConstants.DefaultTimeout,
        baseURL,
    };
};

/**
 * Get axios configuration with credentials for axios api requests.
 * Uses serviceUrlWithCredentials from page context as the base URL, falling back to serviceUrl.
 */
const getDefaultConfigurationWithCredentials = (windowToken: Window): AxiosRequestConfig => {
    const serviceUrlWithCredentials =
        windowToken?.pageContextManager.getSiteData().serviceUrlWithCredentials;
    const serviceUrl = windowToken?.pageContextManager.getSiteData().serviceUrl;
    let baseURL = new URL(serviceUrlWithCredentials || serviceUrl || windowToken?.location.origin)
        .origin;
    return {
        timeout: ApiConstants.DefaultTimeout,
        baseURL,
        withCredentials: true,
    };
};

/**
 * Get default axios configuration for axios api requests
 */
const getNonServiceConfiguration = (): AxiosRequestConfig => {
    return {
        timeout: ApiConstants.DefaultTimeout,
    };
};

export default {
    getDefaultConfiguration,
    getDefaultConfigurationWithCredentials,
    getNonServiceConfiguration,
};
